// extracted by mini-css-extract-plugin
export default {"backToTopButton":"BackToTop__backToTopButton--27X","show":"BackToTop__show--3Bn"};